import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
// import WheelTypeService from "src/service/wheel";
import VehicleDetailsService from "src/service/vehicleDetails";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Vehicle Detail List ",
  },
];

const VehicleDetailsList = () => {
  // ====================================

  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [wheels, setWheels] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  const fetchVehicleDetails = async () => {
    try {
      const res = await VehicleDetailsService.getVehicleDetails({});
      setWheels(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteVehicleDetails = async (id) => {
    swal({
      title: "Delete Vehicle Details",
      text: "Are you sure you want to delete ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await VehicleDetailsService.deleteVehicleDetails({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchVehicleDetails();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchVehicleDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredVehicleData = wheels.filter((item) => {
    const vehicleName = item.vehicle_name
      ? item.vehicle_name.toLowerCase()
      : "";
    const vehicleNo = item.vehicle_no ? item.vehicle_no.toLowerCase() : "";
    const imei_no = item.imei_no ? item.imei_no : "";

    return (
      vehicleName.includes(searchTerm.toLowerCase()) ||
      vehicleNo.includes(searchTerm.toLowerCase()) ||
      imei_no.includes(searchTerm)
    );
  });

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = wheels.filter((item) =>
      item.vehicle_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [wheels, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Vehicle Name",
      "Vehicle Number",
      "Model",
      "Makeing",
      "Device Name",
      "Imei No",
      "Installation Date",
    ];

    const data = visibleData.map((item, index) => [
      index + 1,
      item.vehicle_name,
      item.vehicle_no,
      item.model,
      item.make,
      item.device_name !== null ? item.device_name : "NA",
      item.imei_no !== null ? item.imei_no : "NA",
      item.installation_datetime !== null
        ? moment(item.installation_datetime).format("DD-MM-YYYY")
        : "NA",
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "vehicle Details.xlsx";

    writeFile(wb, fileName);
  };

  // ====================================
  return (
    <PageContainer
      title="Vehicle Detail List"
      description="this is Basic Table page"
    >
      {/* breadcrumb */}
      <Breadcrumb title=" Vehicle Detail List " items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Vehicle Detail List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/installDevice");
              }}
            >
              <IconPlus width={20} />
            </Button>
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "20px;",
              marginTop: "20px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder=" Search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle Number
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Model
                    </Typography>
                  </TableCell> */}
                  {/* <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Make
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Device Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Imei No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Installation Date
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredVehicleData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredVehicleData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {index + 1}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.vehicle_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.vehicle_no}
                          </Typography>
                        </TableCell>
                        {/* <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.model}
                          </Typography>
                        </TableCell> */}
                        {/* <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.make}
                          </Typography>
                        </TableCell> */}
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.device_name !== null
                              ? item.device_name
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.imei_no !== null ? item.imei_no : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {item.installation_datetime !== null
                              ? moment(item.installation_datetime).format(
                                  "DD-MM-YYYY"
                                )
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Link to={`/vehicle/details/${item.vehicle_no}`}>
                            <RemoveRedEyeIcon
                              style={{
                                color: "blue",
                                fontSize: "18px",
                                cursor: "pointer",
                                marginRight: "10px",
                              }}
                            />
                          </Link>

                          <Link to={`/updateVehicleDetails/${item.id}`}>
                            <ModeEditOutlinedIcon
                              style={{
                                color: "blue",
                                fontSize: "18px",
                                cursor: "pointer",
                              }}
                            />
                          </Link>

                          <DeleteOutlinedIcon
                            style={{
                              color: "red",
                              fontSize: "18px",
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => deleteVehicleDetails(item.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={filteredVehicleData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default VehicleDetailsList;
